export interface AdWeek<EventDomain> {
  title: string;
  eventDomains: EventDomain[];
}
